import { render, staticRenderFns } from "./MdSb.vue?vue&type=template&id=8ad8210e&scoped=true"
import script from "./MdSb.vue?vue&type=script&lang=js"
export * from "./MdSb.vue?vue&type=script&lang=js"
import style0 from "./MdSb.vue?vue&type=style&index=0&id=8ad8210e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad8210e",
  null
  
)

export default component.exports